'use client';

import clientFetcher from '@lib/client-fetcher';
import { Subscription } from 'types/collections';

import { DailyAvailability } from '@components/DaySelectionPanel';

/**
 * Service for retrieving subscriptions of the teacher
 */
export class SubscriptionService {
  async getSubscriptions(): Promise<Subscription[]> {
    return await clientFetcher({
      url: '/api/teacher/subscriptions',
    });
  }

  async createSubscriptions(
    listing_id: string,
    selectedDays: DailyAvailability,
  ): Promise<void> {
    return await clientFetcher({
      url: '/api/teacher/subscriptions',
      method: 'POST',
      body: { listing_id, selectedDays },
    });
  }

  async updateSubscriptions(
    subscriptionId: string,
    selectedDays: DailyAvailability,
  ): Promise<void> {
    return await clientFetcher({
      url: `/api/teacher/subscriptions/${subscriptionId}`,
      method: 'PATCH',
      body: { subscriptionId, selectedDays },
    });
  }

  async deleteSubscription(subscriptionId: string): Promise<void> {
    return await clientFetcher({
      url: `/api/teacher/subscriptions/${subscriptionId}`,
      method: 'DELETE',
      body: { subscriptionId },
    });
  }
}
